import {
  Component, Inject, OnInit, OnDestroy,
} from '@angular/core';

@Component({
  selector: 'ut-unified-email-verification-already-verified',
  templateUrl: './already-verified.component.html',
  standalone: false,
})
export class UnifiedEmailVerificationAlreadyVerifiedComponent implements OnInit, OnDestroy {
  redirectCountdown = 3;
  private countdownInterval: any;

  constructor(@Inject('$window') private $window: any) { }

  ngOnInit(): void {
    this.startRedirectCountdown();
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  private startRedirectCountdown(): void {
    this.countdownInterval = setInterval(() => {
      this.redirectCountdown--;
      if (this.redirectCountdown <= 0) {
        this.redirectToLogin();
      }
    }, 1000);
  }

  redirectToLogin(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.$window.location.href = '/login';
  }
}

export default UnifiedEmailVerificationAlreadyVerifiedComponent;
